module.exports = __webpack_public_path__ + "img/refresh.3261930e.svg";